//@flow
import { compose, createStore, applyMiddleware } from 'redux'

import multi from 'redux-multi'
import thunk from 'redux-thunk'

import rootReducer from './reducer'

/**
 * Creates a store with an initial state.
 * @memberof state
 */
export function configureStore(initialState?: Object = {}) {
  const middlewares = applyMiddleware(multi, thunk)

  const store = createStore(
    rootReducer,
    initialState,
    compose(
      middlewares,
      process.env.NODE_ENV !== 'production' && window.devToolsExtension
        ? window.devToolsExtension()
        : f => f,
    ),
  )

  return store
}

const store = configureStore()

export default store



// WEBPACK FOOTER //
// ./src/state/store.js